/**
 * Phone number utilities for E.164 normalization and validation.
 * Default country: Sweden (+46).
 */

/**
 * Normalize phone number to E.164 format.
 * Accepts local Swedish numbers (07X...) or international format (+46...).
 */
export function normalizePhoneToE164(phone: string, defaultCountry: string = 'SE'): string {
  let cleaned = phone.replace(/[^\d+]/g, '');

  if (cleaned.startsWith('+')) {
    return cleaned;
  }

  if (cleaned.startsWith('00')) {
    return '+' + cleaned.substring(2);
  }

  if (cleaned.startsWith('0')) {
    cleaned = cleaned.substring(1);
  }

  const countryCode = defaultCountry === 'SE' ? '46' : '46';
  return `+${countryCode}${cleaned}`;
}

/**
 * Validate phone number (E.164: + followed by 7-15 digits).
 */
export function isValidPhoneNumber(phone: string): boolean {
  const normalized = normalizePhoneToE164(phone);
  return /^\+\d{7,15}$/.test(normalized);
}
